import React, { ReactElement } from "react";
import Layout from '../../components/layout';
import AddProduct from "../../components/products/AddProduct";

const ProductAddPage = (): ReactElement => {
  return (
    <Layout>
      <AddProduct />
    </Layout>
  );
};

export default ProductAddPage;
